import { apply } from '@/api/api';
import { isEmpty } from 'lodash-es';
import { useCallback, useEffect, useRef, useState } from 'react';
import * as SpeechSDK_ from 'microsoft-cognitiveservices-speech-sdk/distrib/browser/microsoft.cognitiveservices.speech.sdk.bundle';
const SpeechSDK = isEmpty(SpeechSDK_) ? window.SpeechSDK : SpeechSDK_;

export const useSpeechRecognition = (textState: boolean) => {
  const recognizerRef = useRef<SpeechSDK_.SpeechRecognizer | null>(null);
  const [startState, setStartState] = useState(false);
  const textStateRef = useRef(textState);
  const intervalRef = useRef<any>(null);
  const [speechText, setSpeechText] = useState<{
    st: number;
    text: string;
    lang: string;
    state: boolean;
  }>({
    st: Date.now(),
    text: '',
    lang: '',
    state: false,
  });
  useEffect(() => {
    textStateRef.current = textState;
  }, [textState]);
  const startInit = async () => {
    setSpeechText({
      st: Date.now(),
      text: '',
      lang: '',
      state: false,
    });
    const info = await apply();
    const token = info.data.data.token;
    const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, 'japaneast');
    speechConfig.setProperty('SpeechServiceResponse_PostProcessingOption', 'TrueText');
    var audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    const autoDetectSourceLanguageConfig = SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([
      'en-US',
      'ja-JP',
      'zh-CN',
      'ko-KR',
      'vi-VN',
    ]);
    autoDetectSourceLanguageConfig.mode = SpeechSDK.LanguageIdMode.Continuous;
    const recognizer = SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);

    recognizer.recognizing = (_s, e) => {
      // console.log(e);
      // console.log(`RECOGNIZING: Text=${e.result.text},  id=${e.result.resultId}`);
      setSpeechText({ text: e.result.text, state: false, lang: e.result.language, st: Date.now() });
    };

    recognizer.recognized = (_s, e) => {
      // console.log(e);
      console.log(`@@speech>>RECOGNIZED: Text=${e.result.text},  id=${e.result.resultId}`);
      setSpeechText({ text: e.result.text, state: true, lang: e.result.language, st: Date.now() });
    };

    recognizer.canceled = (_s, e) => {
      console.log(`##speech CANCELED: Reason=${e.reason}`);
      stop();
      close();
      startInit();
    };
    recognizer.sessionStopped = (_s, e) => {
      console.log('##speech Session stopped.', e.sessionId);
    };
    recognizerRef.current = recognizer;
    intervalRef.current = setInterval(async () => {
      const info = await apply();
      const token = info.data.data.token;
      if (recognizer && token) {
        recognizer.authorizationToken = token;
      }
    }, 10 * 1000 * 60);
    return;
  };
  const startSpeak = () => {
    setSpeechText({
      st: Date.now(),
      text: '',
      lang: '',
      state: false,
    });
    try {
      if (recognizerRef.current)
        recognizerRef.current.startContinuousRecognitionAsync(
          () => {
            console.log('Recognition started.');
            setStartState(true);
            console.log(textStateRef.current);
          },
          (err) => {
            console.error(`Failed to start recognition: ${err}`);
            setStartState(false);
            // close();
            // startInit();
            // startSpeak();
          },
        );
    } catch (e) {
      console.log(e);
      setStartState(false);
    }
  };
  const stop = async () => {
    try {
      if (recognizerRef.current) {
        recognizerRef.current.stopContinuousRecognitionAsync(
          () => {
            setStartState(false);
          },
          (err) => {
            console.error(`Failed to stop recognition: ${err}`);
            setStartState(false);
          },
        );
      }
    } catch (e) {
      console.log(e);
      setStartState(false);
    }
  };
  const close = () => {
    clearInterval(intervalRef.current);
    if (recognizerRef.current) recognizerRef.current.close();
    recognizerRef.current = null;
  };
  return {
    startInit,
    stop,
    speechText,
    startState,
    startSpeak,
  };
};
